import axios from 'axios';
import * as types from "../mutation-types";
import endpoints from "../endpoints";

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {
    // properties to store auth/me data
    login: endpoints.auth.login, //"auth/login",
    login2fa: endpoints.auth.login2fa, //"auth/2fa",
    logout: endpoints.auth.logout, //"auth/logout",
    me: endpoints.auth.me, //"auth/me",
    mePassChange: endpoints.auth.mePassChange, //"auth/change-password",

    authenticated: false,
    profile: {},
  },
  // -----------------------------------------------------------------
  getters: {
    profile: state => state.profile,
    userName: state => state.profile.username,
    emailAddress: state => state.profile.email_address,
    isAuthenticated: state => state.authenticated
  },
  // -----------------------------------------------------------------
  mutations: {
    [types.USER_LOGGED_IN]: (state) => {
      state.authenticated = true;
    },
    [types.USER_LOGGED_OUT]: (state) => {
      state.authenticated = false;
      state.profile = {};
    },
    [types.USER_PROFILE_LOAD]: (state, profile) => {
      state.profile = profile;
    },
  },
  // -----------------------------------------------------------------
  actions: {
    login: (context, loginData) => {

      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.login;

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          data: loginData,
          method: 'POST'
        })
          .then(resp => {
            const r = resp.data;
            if (r.success) {
              if (r.data && r.data.token) {
                resolve(r);
              } else {
                context.dispatch("mePermissions").then((p) => {
                  context.commit(types.USER_LOGGED_IN);
                  context.dispatch('ws/connect', null, {
                    root: true
                  });

                  const rules = p.data.roles;
                  context.dispatch('uiPermissions/loadRules', {
                    rules
                  }, {
                    root: true
                  });
                  resolve(r);
                });
              }
            } else {
              resolve(r);
            }
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },
    login2fa: (context, twofaData) => {

      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.login2fa;

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          data: twofaData,
          method: 'POST'
        })
          .then(resp => {
            const r = resp.data;
            if (r.success) {
              context.dispatch("mePermissions").then((p) => {
                context.commit(types.USER_LOGGED_IN);

                context.dispatch('ws/connect', null, {
                  root: true
                });

                const rules = p.data.roles;
                context.dispatch('uiPermissions/loadRules', {
                  rules
                }, {
                  root: true
                });
                resolve(r);
              });
            } else {
              resolve(r);
            }
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },
    logout: (context) => {
      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.logout;

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          method: 'GET'
        }).then(resp => {
          const r = resp.data;
          resolve(r);
        })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      }).finally(() => {
        context.dispatch('ws/disconnect', null, { root: true });
        context.commit(types.USER_LOGGED_OUT);
        context.commit(`cache/${types.CACHE_INVALIDATE_ALL}`, null, { root: true });
      });
    },
    me: (context) => {
      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.me;
      return new Promise((resolve, reject) => {
        axios({
          url: api,
          method: 'GET'
        }).then(resp => {
          const r = resp.data;
          if (r.success) {
            context.dispatch("mePermissions").then((p) => {
              context.commit(types.USER_LOGGED_IN);
              context.dispatch('ws/connect', null, {
                root: true
              });

              context.commit(types.USER_PROFILE_LOAD, r.data);
              const rules = p.data.roles;
              context.dispatch('uiPermissions/loadRules', {
                rules
              }, {
                root: true
              });
              resolve(r);
            });
          } else {
            resolve(r);
          }
        })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },
    checkMe: (context) => {
      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.me;
      return new Promise((resolve, reject) => {
        axios({
          url: api,
          method: 'GET'
        }).then(resp => {
          const r = resp.data;
          resolve(r);
        })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },
    mePermissions: (context) => {
      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.me + "/permissions";
      return new Promise((resolve, reject) => {
        axios({
          url: api,
          method: 'GET'
        }).then(resp => {
          const r = resp.data;
          resolve(r);
        })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },
    meUpdate: (context, profileData) => {
      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.me;
      return new Promise((resolve, reject) => {
        axios({
          url: api,
          data: profileData,
          method: 'POST'
        }).then(resp => {
          const r = resp.data;
          if (r.success) {
            context.commit(types.USER_PROFILE_LOAD, profileData);
          }
          resolve(r);
        })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },
    meUpdatePassword: (context, passData) => {
      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.mePassChange;
      return new Promise((resolve, reject) => {
        axios({
          url: api,
          data: passData,
          method: 'POST'
        }).then(resp => {
          const r = resp.data;
          resolve(r);
        })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },
    me2FACheck: (context, data) => {
      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.me + "/2fa-check";
      return new Promise((resolve, reject) => {
        axios({
          url: api,
          data: data,
          method: 'POST'
        }).then(resp => {
          const r = resp.data;
          resolve(r);
        })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },
    me2FA: (context, data) => {
      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.me + "/2fa";
      return new Promise((resolve, reject) => {
        axios({
          url: api,
          data: data,
          method: 'POST'
        }).then(resp => {
          const r = resp.data;
          resolve(r);
        })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },
  }
};
